import styles from './Spinner.module.css';

const OffersSpinner = () => {
  return <span className={styles.loader} />;
};

export default OffersSpinner;
